// The advisor id used for ALL System-Access backend lookups (getAdvisorSystems,
// getSystemActionTemplate, getAdvisorSystemLog) and the executeSystemAction
// mutation must be the PERSISTED advisor number — never the live Formik value.
//
// `values.agent_id` can hold an unsaved number while the form is dirty. Because
// the backend now validates `advisor_id` server-side (getSystemActionTemplate &
// executeSystemAction), passing a dirty/unsaved id makes those queries fail with
// ADVISOR_NOT_FOUND and breaks the template/subject preview and the action log in
// an otherwise normal workflow (RITA-1307 Review). The live form values still
// drive the body placeholders (SystemActionDialog `replacePlaceholders`);
// sending stays blocked until saved via `isMailDataDirty`.
//
// `initialValues` is Formik's saved baseline — the last persisted advisor record —
// so it is the correct source for the lookup id regardless of in-flight edits.
export function getPersistedAdvisorId(initialValues: { agent_id: number }): number {
  return initialValues.agent_id;
}

export default getPersistedAdvisorId;
